<template>
  <div id="world"></div>
</template>
<script>
import G2 from "@antv/g2";
import DataSet from '@antv/data-set';
export default {
  data() {
    return {
      chart: null,
      worlddata: [
        { x: "信访举报", value: 1383220000, category: "asia" },
        { x: "上级交办", value: 1316000000, category: "asia" },
        { x: "司法机关移送", value: 324982000, category: "america" },
        { x: "审计中发现", value: 263510000, category: "asia" },
        { x: "监督检查中发现", value: 207505000, category: "america" },
        { x: "纪律审查中发现", value: 196459000, category: "asia" },
        { x: "巡视中发现", value: 191836000, category: "africa" },
        { x: "其它", value: 162459000, category: "asia" },
        { x: "Russia", value: 146804372, category: "europe" },
        { x: "Japan", value: 126790000, category: "asia" },
        { x: "Mexico", value: 123518000, category: "america" },
        { x: "Ethiopia", value: 104345000, category: "africa" },
        { x: "Philippines", value: 104037000, category: "asia" },
        { x: "Egypt", value: 93013300, category: "africa" },
        { x: "Vietnam", value: 92700000, category: "asia" },
        { x: "Germany", value: 82800000, category: "europe" }
      ]
    };
  },
  props: {
    id: String
  },
  mounted: function() {
    this.drawChart(this.worlddata); // 第一步想到的是创建的时候更新图表，但是这个不适用于异步请求接口获取相关数据，所以采用下面的监听的方式
  },
  beforeUpdate: function() {
    //      this.drawChart();
  },
  watch: {
    // charData: function (val, oldVal) {    // 监听charData，当放生变化时，触发这个回调函数绘制图表
    //   console.log('new: %s, old: %s', val, oldVal);
    //   this.drawChart(val);
    // }
  },
  methods: {
    drawChart: function(datas) {
      function getTextAttrs(cfg) {
        return _.assign({}, cfg.style, {
          fillOpacity: cfg.opacity,
          fontSize: cfg.origin._origin.size,
          rotate: cfg.origin._origin.rotate,
          text: cfg.origin._origin.text,
          textAlign: "center",
          fontFamily: cfg.origin._origin.font,
          fill: cfg.color,
          textBaseline: "Alphabetic"
        });
      }
      G2.Shape.registerShape("point", "cloud", {
        drawShape: function drawShape(cfg, container) {
          var attrs = getTextAttrs(cfg);
          return container.addShape("text", {
            attrs: _.assign(attrs, {
              x: cfg.x,
              y: cfg.y
            })
          });
        }
      });
      let data = datas;
      var dv = new DataSet.View().source(data);
    var range = dv.range('value');
    var min = range[0];
    var max = range[1];
    dv.transform({
      type: 'tag-cloud',
      fields: ['x', 'value'],
      size: [window.innerWidth, window.innerHeight],
      font: 'Verdana',
      padding: 0,
      timeInterval: 5000, // max execute time
      rotate: function rotate() {
        var random = ~~(Math.random() * 4) % 4;
        if (random == 2) {
          random = 0;
        }
        return random * 90; // 0, 90, 270
      },
      fontSize: function fontSize(d) {
        if (d.value) {
          return (d.value - min) / (max - min) * (80 - 24) + 24;
        }
        return 0;
      }
    });
      // 如果图形存在则删除再创建，这个地方感觉稍微有点坑
      // 具体的G2 api函数说明请看上面提供的官网地址，此处不再逐一说明
      this.chart && this.chart.destroy();
      //let data = datas;
      this.chart = new G2.Chart({
        id: "world",
        width: 1143,
        height: 590
      });
      this.chart.source(dv, {
        x: {
          nice: false
        },
        y: {
          nice: false
        }
      });
      this.chart.legend(false);
      this.chart.axis(false);
      this.chart.tooltip({
        showTitle: false
      });
      this.chart.coord().reflect();
      this.chart
        .point()
        .position("x*y")
        .color("category")
        .shape("cloud")
        .tooltip("value*category");
      this.chart.render();
    }
  }
};
</script>
<style lang="less" scoped>
</style>
